import { CleanLink } from '@components/gassan-ui/Link/CleanLink'
import { Box, breakpoints, Container, Image, Track, useSlider } from '@gassan-ui'
import { useBreakpoint } from '@lib/hooks/useBreakpoint'
import { Heading, Text } from '@rolex-ui'
import _chunk from 'lodash.chunk'
import { rem } from 'polished'
import React, { FC, Fragment, useRef } from 'react'
import Indicators from '../Indicators'
import SliderNavButton from '../SliderNavButton'
import * as S from './elements'

type Item = {
  href: string
  title: string
  subtitle: string
  images: string[]
  placeholderSrc: string
}

type Props = {
  slides: Item[]
  title: string
}

const RelatedProductsSlider: FC<Props> = ({ slides, title }) => {
  const isTabletUp = useBreakpoint(breakpoints.small)
  const chunks = _chunk(slides, isTabletUp ? 3 : 2)
  const trackRef = useRef<HTMLElement>(null)
  const { onTouchEnd, prev, next, canMoveRight, canMoveLeft, index, goToIndex } = useSlider({
    trackRef
  })
  return (
    <Container maxWidth={{ _: '90%', large: rem(1140) }} py="10vh">
      <Heading variant="mediumTitle" as="h2" textAlign="center" mb={rem(30)}>
        {title}
      </Heading>
      <Box mb={{ _: rem(30), medium: rem(35), large: '2.5rem' }} position="relative">
        <Track ref={trackRef} onTouchEnd={onTouchEnd}>
          {chunks.map((chunk, key) => (
            <Fragment key={key}>
              <S.Slide
                display="grid"
                gridTemplateColumns={{ _: '1fr 1fr', small: '1fr 1fr 1fr' }}
                gridGap={['0.5rem', '0.75rem']}
                minWidth="100%"
              >
                {chunk.map((slide, key) => (
                  <CleanLink href={slide.href} key={key}>
                    <Image
                      loading={index < 4 ? 'eager' : 'delayed'}
                      sources={slide.images}
                      ratio={[1.12]}
                      placeholderSrc={slide.placeholderSrc}
                    />
                    <Box textAlign="center" pt="10px" px={2}>
                      <Heading mb={0} variant="subtitle" as="h4">
                        Rolex
                      </Heading>
                      <Heading mb={0} variant="smallTitle" as="h3">
                        {slide.title}
                      </Heading>
                      <Text variant="smallDescription" mb={0} as="h4">
                        {slide.subtitle}
                      </Text>
                    </Box>
                  </CleanLink>
                ))}
              </S.Slide>
            </Fragment>
          ))}
        </Track>
        {chunks.length > 1 && (
          <S.NavButtons>
            <SliderNavButton direction="prev" onClick={prev} disabled={!canMoveLeft} />
            <SliderNavButton direction="next" onClick={next} disabled={!canMoveRight} />
          </S.NavButtons>
        )}
      </Box>
      {chunks.length > 1 && (
        <Indicators
          activeIndex={index}
          onClick={index => {
            goToIndex(index)
          }}
          count={chunks.length}
        />
      )}
    </Container>
  )
}

export default RelatedProductsSlider
